/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_How_1_TitleInputs */

const en_vc_onl_how_1_title = /** @type {(inputs: Vc_Onl_How_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runs on your computer`)
};

const zh_vc_onl_how_1_title = /** @type {(inputs: Vc_Onl_How_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在你的电脑上运行`)
};

/**
* | output |
* | --- |
* | "Runs on your computer" |
*
* @param {Vc_Onl_How_1_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_how_1_title = /** @type {((inputs?: Vc_Onl_How_1_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_How_1_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_how_1_title(inputs)
	return zh_vc_onl_how_1_title(inputs)
});
export { vc_onl_how_1_title as "vc.onl.how.1.title" }